(() => {
  const offers = [...document.querySelectorAll("[data-roren-pdp-offer]")];
  if (!offers.length) return;

  const firstOffer = offers[0];
  const productRoot = firstOffer.closest("product-info") || document;
  const variantsNode = productRoot.querySelector("[data-roren-offer-variants]");
  let variants = [];

  try {
    variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  } catch (error) {
    variants = [];
  }

  const startAt = Number(firstOffer.dataset.startsAt) * 1000;
  const endAt = Number(firstOffer.dataset.endsAt) * 1000;
  const rate = Number(firstOffer.dataset.rate || 40);
  const currency = firstOffer.dataset.currency || "AUD";
  const formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
  });

  const getState = () => {
    const now = Date.now();
    if (now < startAt) return "upcoming";
    if (now >= endAt) return "ended";
    return "active";
  };

  const getSelectedVariant = () => {
    const variantInput = productRoot.querySelector(".product-variant-id");
    if (!variantInput) return variants[0];
    return variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
  };

  const updateOffer = () => {
    const state = getState();
    const variant = getSelectedVariant();
    const saving = variant ? Math.round((variant.price * rate) / 100) : 0;
    const salePrice = variant ? variant.price - saving : 0;
    const formattedSaving = formatter.format(saving / 100);
    const formattedSalePrice = formatter.format(salePrice / 100);
    const formattedRegularPrice = formatter.format((variant?.price || 0) / 100);

    offers.forEach((offer) => {
      offer.hidden = state === "ended";
      offer.dataset.state = state;

      if (offer.dataset.placement === "title") {
        const title = offer.querySelector("[data-roren-offer-title]");
        if (title) {
          title.textContent = state === "active" ? "40% Off" : "40% Off · from 2:21 pm";
        }
      }

      if (offer.dataset.placement === "price") {
        const save = offer.querySelector("[data-roren-offer-save]");
        const regular = offer.querySelector("[data-roren-offer-regular]");
        const sale = offer.querySelector("[data-roren-offer-sale]");
        if (save) {
          save.textContent =
            state === "active" ? `Save ${formattedSaving}` : `Save ${formattedSaving} after 2:21 pm`;
        }
        if (regular) regular.textContent = formattedRegularPrice;
        if (sale) sale.textContent = formattedSalePrice;
      }
    });
  };

  updateOffer();
  window.setInterval(updateOffer, 10_000);
  document.addEventListener("change", (event) => {
    if (event.target.closest("variant-selects, variant-radios, product-info, .product-form")) {
      window.setTimeout(updateOffer, 0);
    }
  });
})();
